import React, { useEffect, useRef, useState } from "react";
import HomeDashboardLayout from "../HomeDashboardLayout";
import "../../dashboard/Dashboard.css";
import "../HomeDashboard.css";
import "../DashboardFavoriteExam.css";
import HeaderProfileSection from "../HeaderProfileSection";
import "../../DashboardQuestionBank.css";
import SubjectCategorySlider from "../../SubjectCategorySlider";
import GamificationSubjectCard from "./GamificationSubjectCard";
import "./GamificationSubjectCategories.css";
import heroImg from "../../assets/images/qb1.png";
import profileImg from "../../assets/images/profile1.png";
import languageImg from "../../assets/images/lang.png";
import CoinConverterGif from "../../assets/images/Coin-converter.gif";

import { BackSVG } from "../../components/SvgIcons";

const GamificationSubject = () => {
  const [topicsEnabled, setTopicsEnabled] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const profileMenuRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (profileMenuRef.current && !profileMenuRef.current.contains(event.target)) {
        setIsProfileOpen(false);
      }
    };

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setIsProfileOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.removeEventListener("keydown", handleEscape);
    };
  }, []);

  return (
    <>
      <style>
        {`
       .homeDashboard-wrapper .page-content {
         padding-right: 0;
       }
      .layout-wrapper.homeDashboard-wrapper {
         background: linear-gradient(to bottom, rgba(103, 78, 221, 0.05) 0%, #fff 100%)!important;
       }
        `}
      </style>
      <HomeDashboardLayout showHeader={false}>
        {/* Question Bank Header Section */}
        <section className="qb" aria-label="Question bank introduction">
              <div className="hideProfile-page ">
               <div className="categories-page-header mb-0">
            <div>
                <button
                type="button"
                className="categories-back-button"   >
                <i className="bi bi-chevron-left"></i>
                </button>
            </div>
           <div>
            <h1 className="categories-page-title">
        
            </h1>
           </div>
            <div>
               <HeaderProfileSection/>
            </div>
          </div>
          </div>

          <div className="qb-body">
            <div className="d-flex align-items-center justify-content-center">
            <div className="qb-copy">
              <div className="qb-loc">
                <i className="bi bi-geo-alt-fill" aria-hidden="true" />
                <span>  Gamification</span>
              </div>

              <h1 className="qb-title">
                Group  <span> Battle</span>
              </h1>

              <p className="qb-sub">Choose Subject for Random attle </p>

              <div className="qb-topics-row subject-gap">
               <div className="subject-badge">
               <i className="bi bi-book-half"></i> 
               <span className="subject-text">
                    8 subjects available
                </span>
                </div>
                  <div className="game-coin d-flex gap-2 justify-content-center align-items-center d-flex ">
                    <span><img src={CoinConverterGif} alt="" /></span>
                    <span className="coin-valuee fw-bold"> 400 </span>
                  </div>
              </div>

           
            </div>

            <div className="qb-visual" aria-hidden="true">
              <div className="qb-dots">
                {Array.from({ length: 21 }).map((_, index) => (
                  <span key={index} />
                ))}
              </div>

              <img src={heroImg} alt="" className="qb-hero" />
            </div>
          </div>
             <label className="qb-search" aria-label="Search subjects">
                <i className="bi bi-search" aria-hidden="true" />
                <input type="text" placeholder="Search subjects" aria-label="Search subjects" />
              </label>
          </div>
        </section>

        {/* End Question Bank Header Section */}

        <div className="innerContent dashboardExam">
          {/* Subject Category Section */}
          <div>
            <div className="quick-action__header">
              <h2 id="quick-action-title" className="quick-action__title">
                Subject Categories
              </h2>
            </div>
            <SubjectCategorySlider />
          </div>
          {/* Subject Category Section */}

          {/* Question Bank Subject Section */}
          <div className="m-20">
            <GamificationSubjectCard />
          </div>
          {/* Question Bank Subject Section */}
        </div>
      </HomeDashboardLayout>
    </>
  );
};

export default GamificationSubject;

